import script from "./PriceshowOtherBranchModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceshowOtherBranchModal.vue?vue&type=script&lang=ts&setup=true"

import "./PriceshowOtherBranchModal.vue?vue&type=style&index=0&id=e5d721dc&lang=scss"

const __exports__ = script;

export default __exports__